import {createContext} from 'react';
import { useState, useEffect } from 'react';

export const TemaContext = createContext();

export const TemaProvider = ({ children }) => {
    const [tema, setTema] = useState(() => {
      // Tenta recuperar o tema salvo
      const stored = localStorage.getItem('tema');
      return stored ? JSON.parse(stored) : 'claro'; // 'claro' ou o padrão que quiser
    });
  
    useEffect(() => {
      localStorage.setItem('tema', JSON.stringify(tema));
    }, [tema]);
  
    return (
      <TemaContext.Provider value={{ tema, setTema }}>
        {children}
      </TemaContext.Provider>
    );
  };